/**
 * Profil
 */
export interface Profil {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  mobile: string;
}
export const initialProfil: Profil = {
  id: 0,
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  mobile: ""
};
/**
 * Organization
 */
export interface Organization {
  id: number;
  logo: string;
  city: string;
  adress: string;
  name: string;
  zipCode: string;
  country: string;
}
export const initialOrganization: Organization = {
  id: 0,
  logo: "",
  city: "",
  adress: "",
  name: "",
  zipCode: "",
  country: ""
};
/**
 * Contact
 */
export interface Contact {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  avatar: string;
}
export const initialContact: Contact = {
  id: 0,
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  avatar: ""
};
/**
 * State
 * Implement User, Organization and Contact
 */
export interface State {
  profil: Profil;
  organization: Organization;
  contact: Contact;
}
export const initialState: State = {
  profil: initialProfil,
  organization: initialOrganization,
  contact: initialContact
};



// WEBPACK FOOTER //
// ./src/redux/user/state.ts